const HEX_LABELS = [
  'SEQ', 'PCR', 'MS',  'FLOW',
  'NMR', 'BIOR','LIMS','AI',
  'ML',  'QC',  'ELN', 'CDS',
  'API', 'FDA', 'GMP', 'PAT',
];

const ACTIVE_INDICES = new Set([1, 3, 7, 8, 11, 14]);
const PURPLE_INDICES = new Set([7, 8]);

const PULSE_INTERVAL_MS = 1200;

/**
 * Populates the technology section's status grid and runs a low-frequency
 * pulse to suggest live activity. Idempotent — safe to call before DOM ready.
 */
export function initHexGrid(gridId = 'hexGrid') {
  const grid = document.getElementById(gridId);
  if (!grid) return;

  const fragment = document.createDocumentFragment();
  HEX_LABELS.forEach((label, i) => {
    const cell = document.createElement('div');
    cell.className = 'hex-cell';
    if (PURPLE_INDICES.has(i)) cell.classList.add('purple-active');
    else if (ACTIVE_INDICES.has(i)) cell.classList.add('active');
    cell.textContent = label;
    cell.setAttribute('data-tip', label);
    fragment.appendChild(cell);
  });
  grid.appendChild(fragment);

  setInterval(() => {
    const cells = grid.querySelectorAll('.hex-cell');
    if (cells.length === 0) return;
    const r = Math.floor(Math.random() * cells.length);
    cells[r].classList.toggle('active');
  }, PULSE_INTERVAL_MS);
}
